import React from 'react'
import styled from 'styled-components'
import Modal from '@material-ui/core/Modal'
import Spinner from 'components/UI/Spinner'
import CloseRounded from '@material-ui/icons/CloseRounded'
import { mobileSize } from 'theme'

const modalStyle = { display: 'flex', outline: 'none', alignItems: 'center' }

const AlertDialog = ({
  open,
  handleClose,
  buttonText,
  subButtonText,
  buttonClick,
  subButtonClick,
  title,
  description,
  isLoading,
  image,
  SvgComponent,
  children,
}) => {
  const topImage = image ? (
    <Image src={image} />
  ) : SvgComponent ? (
    <SvgComponent />
  ) : null

  const AlertButton = () => {
    if (isLoading) {
      return (
        <Button>
          <Spinner size={24} />
        </Button>
      )
    }
    return (
      <>
        <Button onClick={buttonClick}>{buttonText}</Button>
        {subButtonText && (
          <SubButton onClick={subButtonClick}>{subButtonText}</SubButton>
        )}
      </>
    )
  }
  return (
    <Modal
      open={open}
      onClose={handleClose}
      style={modalStyle}
      disableBackdropClick
    >
      <AlertBody>
        <CloseButton onClick={handleClose} />
        <Container append={!!children}>
          {topImage}
          {title && <Title>{title}</Title>}
          {description && (
            <Description marginTop={topImage ? '24px' : '8px'}>
              {description}
            </Description>
          )}
          {buttonText && <AlertButton>{buttonText}</AlertButton>}
        </Container>
        {children}
      </AlertBody>
    </Modal>
  )
}

const AlertBody = styled.div`
  position: relative;
  text-align: center;
  background: #fff;
  min-width: 400px;
  max-width: 480px;
  min-height: 180px;
  border-radius: 5px;
  margin: 0 auto;
  outline: none;
  box-sizing: border-box;
  @media ${mobileSize} {
    min-width: 280px;
    max-width: 90%;
  }
`
const Container = styled.div`
  padding: 32px;
  ${(p) => p.append && 'padding-bottom: 16px;'}
`
const CloseButton = styled(CloseRounded)`
  color: #878b92;
  position: absolute;
  right: 8px;
  top: 8px;
`
const Image = styled.img`
  width: 120px;
  height: 120px;
`
const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${(p) => p.theme.color.dark100};
  padding-bottom: 8px;
`
const Description = styled.div`
  font-size: 14px;
  color: ${(p) => p.theme.color.dark100};
  margin-top: ${(p) => p.marginTop};
`
const Button = styled.div`
  width: 192px;
  height: 40px;
  border-radius: 4px;
  color: #fff;
  background: ${(p) => p.theme.color.blue200};
  line-height: 40px;
  font-size: 16px;
  margin: auto;
  margin-top: 16px;
  cursor: pointer;
`
const SubButton = styled.div`
  font-size: 14px;
  color: ${(p) => p.theme.color.blue200};
  line-height: 1.5;
  margin-top: 16px;
  cursor: pointer;
`
export default AlertDialog
